<template>
  <button type="button" class="btn btn-success" @click="show = true">Add Journey</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-if="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Journey</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <form ref="addJourney">
            <div class="row mb-3">
              <div class="col-md-4">
                <label for="" class="form-label">Trip</label>
                <select class="form-select" v-model="journey.trip">
                  <option value=""></option>
                  <option value="round">Roundtrip</option>
                  <option value="oneway">One Way</option>
                </select>
              </div>

              <div class="col-md-4">
                <label for="" class="form-label">Type</label>
                <select class="form-select" v-model="journey.type" @change="getOperators(this.value)">
                  <option value=""></option>
                  <option v-for="product in types" :key="product.id" :value="product.id">
                    {{ product.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-4" v-if="auth.user.agency.id === 1">
                <label for="" class="form-label">Operator</label>
                <select class="form-select" v-model="journey.operator" :disabled="operators.length ? disabled : ''">
                  <option value=""></option>
                  <option v-for="operator in operators" :key="operator.id" :value="operator.id">
                    {{ operator.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="departure">
                  <h5>Departure</h5>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="">From</label>
                      <select class="form-select" v-model="journey.departure.from" @change="setReturnTo($event)">
                        <option :value="null"></option>
                        <option v-for="airport in airports" :key="airport.id" :value="airport.id">
                          {{ airport.iata }} | {{ airport.island_city }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label for="">To</label>
                      <select class="form-select" v-model="journey.departure.to" @change="setReturnFrom($event)">
                        <option :value="null"></option>
                        <option v-for="airport in airports" :key="airport.id" :value="airport.id">
                          {{ airport.iata }} | {{ airport.island_city }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Departure Date & Time</label>
                    <div class="input-group">
                      <input type="date" class="form-control" v-model="journey.departure.departure_date" @change="setDepartureArrivalDate($event)" />
                      <input type="time" class="form-control" v-model="journey.departure.departure_time" />
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Arrival Date & Time</label>
                    <div class="input-group">
                      <input type="date" class="form-control" v-model="journey.departure.arrival_date" />
                      <input type="time" class="form-control" v-model="journey.departure.arrival_time" />
                    </div>
                  </div>

                  <div class="mb-3" v-if="auth.user.agency.id === 1">
                    <label class="form-label">Flight Number</label>
                    <input type="text" class="form-control" v-model="journey.departure.flight_number" />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="return" v-if="journey.trip === 'round'">
                  <h5>Return</h5>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="">From</label>
                      <select class="form-select" v-model="journey.return.from">
                        <option :value="null"></option>
                        <option v-for="airport in airports" :key="airport.id" :value="airport.id">
                          [{{ airport.iata }}] {{ airport.island_city }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label for="">To</label>
                      <select class="form-select" v-model="journey.return.to">
                        <option :value="null"></option>
                        <option v-for="airport in airports" :key="airport.id" :value="airport.id">
                          [{{ airport.iata }}] {{ airport.island_city }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Departure Date & Time</label>
                    <div class="input-group">
                      <input type="date" class="form-control" v-model="journey.return.departure_date" @change="setReturnArrivalDate($event)" />
                      <input type="time" class="form-control" v-model="journey.return.departure_time" />
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Arrival Date & Time</label>
                    <div class="input-group">
                      <input type="date" class="form-control" v-model="journey.return.arrival_date" />
                      <input type="time" class="form-control" v-model="journey.return.arrival_time" />
                    </div>
                  </div>

                  <div class="mb-3" v-if="auth.user.agency.id === 1">
                    <label class="form-label">Flight Number</label>
                    <input type="text" class="form-control" v-model="journey.return.flight_number" />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Cancel</button>
          <button type="button" class="btn btn-primary" @click="AddJourney()">Save Journey</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AddJourneyModal',
  props: ['form', 'types', 'airports'],
  data() {
    return {
      show: false,
      journey: {
        trip: 'round',
        type: null,
        operator: null,
        departure: {
          from: null,
          to: null,
          departure_date: null,
          departure_time: null,
          arrival_date: null,
          arrival_time: null,
          flight_number: null,
        },
        return: {
          from: null,
          to: null,
          departure_date: null,
          departure_time: null,
          arrival_date: null,
          arrival_time: null,
          flight_number: null,
        }
      },
      operators: []
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    async getOperators() {
      let typeId = this.journey.type
      if (typeId) {
        const getOperator = await axios.get(`/settings/get/operators`, {
          params: { 'types': typeId }
        })
        this.operators = getOperator.data;
      }
    },
    reset() {
        Object.assign(this.$data, this.$options.data())
    },
    setReturnTo(event) {
      if (this.journey.trip === 'round') {
        this.journey.return.to = event.target.value
      }
    },
    setReturnFrom(event) {
      if (this.journey.trip === 'round') {
        this.journey.return.from = event.target.value
      }
    },
    setDepartureArrivalDate(event) {
      this.journey.departure.arrival_date = event.target.value
    },
    setReturnArrivalDate(event) {
      this.journey.return.arrival_date = event.target.value
    },
    AddJourney() {
      this.form.journeys.push(this.journey)

      this.reset()
    }
  }
}
</script>

<style>

</style>
